import magnifiAPIInstance from "./apiInstance";

export const tournamentsAPIs = {
  getTournaments: ({ payload }) => magnifiAPIInstance.post(`/tournaments`, payload),
  getTournamentsList: ({ payload }) => magnifiAPIInstance.post(`/get-tournaments`, payload),
  getTournamentById: ({ payload }) => magnifiAPIInstance.post(`/api/v3/get-tournament-details-by-id`, payload),
  createNewTournament: ({ payload }) => magnifiAPIInstance.post(`/tournament/create`, payload),
  deleteTournament: ({ payload }) => magnifiAPIInstance.post(`/tournament/delete`, payload),
  updateTournament: ({ payload }) => magnifiAPIInstance.post(`/tournament/update`, payload),
  getAllTournaments: ({ entityId, payload }) => magnifiAPIInstance.get(`/api/v3/tournament/${entityId}`, payload),
  validateAddTournamentThroughCsv: ({ payload }) => magnifiAPIInstance.post(`/api/v3/tournament/validate/csv`, payload),
  createBulkTournaments: ({ payload }) => magnifiAPIInstance.post(`/api/v3/tournament/create/many`, payload),
  getTournamentDataById: ({ payload }) => magnifiAPIInstance.post(`/get-tournaments-by-id`, payload),
  updateTournamentScoreboard: ({ payload }) => magnifiAPIInstance.post(`/update_tournament`, payload),
};
